export default {
  set(name, value, ttl, domain) {
    let expires = '';
    let cookieDomain = '';
    if (ttl) {
      const date = new Date();
      date.setTime(date.getTime() + ttl * 60 * 1000);
      expires = `; expires=${date.toGMTString()}`;
    }
    if (domain) {
      cookieDomain = `; domain=${domain}`;
    }
    document.cookie = `${name}=${escape(value)}${expires}${cookieDomain}; path=/`;
  },
  get(name) {
    let i;
    let c;
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (i = 0; i < ca.length; i += 1) {
      c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return unescape(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  },
  delete(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },
};
